import React from 'react';

/** The dashboard's one bold moment — everything below it (tinted stat
 * tiles, panels) stays quiet so this carries the color. A diagonal
 * primary→accent wash (the app's own two brand hues, not a generic
 * purple-to-pink) with a faint dot-grid for texture, matching the
 * treatment already used on the marketing Landing page's hero. */
export default function DashboardHero({ greeting, subtitle, stat }) {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-primary-700 via-primary-600 to-accent-500 px-6 py-6 sm:py-7 mb-4">
      <div
        className="absolute inset-0 opacity-[0.15] pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(rgba(255,255,255,0.6) 1px, transparent 1px)',
          backgroundSize: '20px 20px',
        }}
      />
      <div className="relative flex items-center justify-between gap-4 flex-wrap">
        <div>
          <h1 className="text-xl sm:text-2xl font-display font-bold text-white text-balance">{greeting}</h1>
          {subtitle && <p className="text-primary-100 text-sm mt-1">{subtitle}</p>}
        </div>
        {stat && (
          <div className="text-right shrink-0">
            <p className="text-3xl sm:text-4xl font-display font-bold text-white tabular-nums leading-none">{stat.value}</p>
            <p className="text-primary-100 text-xs mt-1">{stat.label}</p>
          </div>
        )}
      </div>
    </div>
  );
}
